export const IMAGE_MAX_SIZE_BYTES = 650 * 1024

export const FIRESTORE_COLLECTIONS = Object.freeze({
  users: 'Users',
  coursesOrders: 'CoursesOrders',
  eventsOrders: 'EventsOrders',
  conferenceApplications: 'ConferenceApplications',
  feedBack: 'FeedBack',
  callBack: 'CallBack',
  courses: 'Courses',
  startedCourses: 'StartedCourses',
  testBank: 'TestBank',
  testAttempts: 'TestAttempts',
  events: 'Events',
  team: 'Team',
  categories: 'Categories',
  blog: 'Blog',
  additionalPages: 'AdditionalPages',
  generalInfo: 'GeneralInfo',
  siteSeo: 'SiteSeo'
})

export const LOCAL_COLLECTION_TO_FIRESTORE = Object.freeze({
  team: FIRESTORE_COLLECTIONS.team,
  courseApplications: FIRESTORE_COLLECTIONS.coursesOrders,
  eventApplications: FIRESTORE_COLLECTIONS.eventsOrders,
  courses: FIRESTORE_COLLECTIONS.courses,
  startedCourses: FIRESTORE_COLLECTIONS.startedCourses,
  testBank: FIRESTORE_COLLECTIONS.testBank,
  testAttempts: FIRESTORE_COLLECTIONS.testAttempts,
  events: FIRESTORE_COLLECTIONS.events,
  blogs: FIRESTORE_COLLECTIONS.blog,
  additionalPages: FIRESTORE_COLLECTIONS.additionalPages
})

export const CATEGORY_DOCUMENTS = Object.freeze({
  courseCategories: 'courses',
  eventCategories: 'events',
  blogCategories: 'blog'
})

export const GENERAL_INFO_DOCUMENTS = Object.freeze({
  general: 'general',
  pages: 'pages'
})

export const STORAGE_FOLDERS = Object.freeze({
  [FIRESTORE_COLLECTIONS.users]: 'users',
  [FIRESTORE_COLLECTIONS.coursesOrders]: 'courses-orders',
  [FIRESTORE_COLLECTIONS.eventsOrders]: 'events-orders',
  [FIRESTORE_COLLECTIONS.conferenceApplications]: 'conference-applications',
  [FIRESTORE_COLLECTIONS.courses]: 'courses',
  [FIRESTORE_COLLECTIONS.startedCourses]: 'started-courses',
  [FIRESTORE_COLLECTIONS.testBank]: 'test-bank',
  [FIRESTORE_COLLECTIONS.testAttempts]: 'test-attempts',
  [FIRESTORE_COLLECTIONS.events]: 'events',
  [FIRESTORE_COLLECTIONS.team]: 'team',
  [FIRESTORE_COLLECTIONS.categories]: 'categories',
  [FIRESTORE_COLLECTIONS.blog]: 'blog',
  [FIRESTORE_COLLECTIONS.additionalPages]: 'additional-pages',
  [FIRESTORE_COLLECTIONS.generalInfo]: 'general-info'
})

export function firestoreCollectionForLocalKey(collectionKey) {
  return LOCAL_COLLECTION_TO_FIRESTORE[collectionKey] || collectionKey
}

export function storageFolderForCollection(collectionName) {
  return STORAGE_FOLDERS[collectionName] || collectionName
}
